import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
  ADRPROGRESS_FEATURE_KEY,
  AdrState,
  AdrPartialState,
  adrAdapter,
} from "./adr.reducer";
import { AdrDto, SuitProgressDto } from "@cradua/data";

// Lookup the 'Adr' feature state managed by NgRx
export const getAdrState = createFeatureSelector<
  AdrPartialState,
  AdrState
>(ADRPROGRESS_FEATURE_KEY);

const { selectAll, selectEntities } = adrAdapter.getSelectors();

// export const getAdrLoaded = createSelector(
//   getAdrState,
//   (state: AdrState) => state.loaded,
// );

export const getAdrError = createSelector(
  getAdrState,
  (state: AdrState) => state.error,
);

export const loadingAdr = createSelector(
  getAdrState,
  (state: AdrState) => state.loaded,
);

export const getAllAdr = createSelector(
  getAdrState,
  (state: AdrState) => selectAll(state),
);

export const getAdrEntities = createSelector(
  getAdrState,
  (state: AdrState) => selectEntities(state),
);

export const getSelectedId = createSelector(
  getAdrState,
  (state: AdrState) => state.selectedAdrId,
);

export const getSelected = createSelector(
  getAdrEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId],
);

export const getLastInsertedValue = createSelector(
  getAllAdr,
  (adr: AdrDto[]) => adr[0],
);

export const getSearchAdr = createSelector(
  getAllAdr,
  getSelectedId,
  (adr: AdrDto[], selectedId) => {
    if (selectedId === ".") {
      return adr;
    }

    return !selectedId ? null : adr.filter(
      (item) =>
        item.SuitNo.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ) ||
        item.PartyA.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        ) ||
        item.PartyB.toLowerCase().includes(
          String(selectedId).toLowerCase(),
        )
    );
  },
);

export const getSearchadrId = createSelector(
  getAllAdr,
  getSelectedId,
  (adr: AdrDto[], selectedId) =>
    adr.find((item) => item.id === selectedId),
);